<div class="doc-insidecard">
  <div *ngIf="isLoading" class="loader">
    <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
  </div>

  <ng-container *ngIf="navigateToStepperForm">
    <wm-app class="view"></wm-app>
  </ng-container>

  <ng-container *ngIf="navigateToSummary && !isLoading && applicationSummaryDetails?.application">
    <div class="application-actions-row">
      <app-application-actions
        [statusCode]="applicationSummaryDetails.application.status"
        [appId]="row.createdApplicationId"
        [applicationNumber]="applicationSummaryDetails.application.combinedApplicationNumber"
        [workflowId]="applicationSummaryDetails.workflowId"
        [versionId]="applicationSummaryDetails.workflowVersionId"
        [handleReopenInParent]="true"
        (applicationReopened)="onApplicationReopened()">
      </app-application-actions>
    </div>
    <wm-edit-application-janus
      [appID]="row.createdApplicationId"
      [janusApplicationSummaryDetails]="applicationSummaryDetails">
    </wm-edit-application-janus>
  </ng-container>
</div>
